import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import {
  SearchFacade,
  SearchStore,
  SearchBookmarkService,
  SearchDataService,
  SearchRelatedFacade,
  SearchEndorsedFacade,
} from '.';
import { SearchMarketplaceService } from '@app/search/components/search-view/search-reactive-store/search-marketplace.service';

// Cannot use `freezeStores()` from '@dg/shared-rsm' since LearningResourceViewModel which has circular references
// TODO: change LearningResourceViewModel to be raw data snapshot only

@NgModule({
  imports: [RouterModule, CommonModule],
  providers: [
    SearchFacade,
    SearchRelatedFacade,
    SearchEndorsedFacade,
    SearchDataService,
    SearchStore,
    SearchBookmarkService,
    SearchMarketplaceService,
  ],
})
export class SearchReactiveStoreModule {}
